import React from "react";
import "../assets/css/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <>

      <main className="privacy-policy">
        <section className="container">
          <h1>Privacy Policy</h1>
          <p className="updated-date">Last Updated: 30th December 2025</p>

          <p>
            AutoAssure360 ("we", "our", "us") respects your privacy and is committed
            to protecting the personal information you share with us. This Privacy
            Policy explains how we collect, use, and safeguard information collected
            through our website.
          </p>

          <p>
            This website is an informational website only and does not require user
            registration or login. Personal data is collected solely through the
            <strong> Contact Us</strong> form.
          </p>

          <p>This policy applies to our operations in:</p>
          <ul>
            <li>
              <strong>India</strong>, in accordance with the Digital Personal Data
              Protection Act, 2023 (DPDPA)
            </li>
            <li>
              <strong>United Arab Emirates (UAE)</strong>, in accordance with the
              Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data (PDPL)
            </li>
          </ul>

          <h2>1. Information We Collect</h2>
          <p>
            We collect limited personal information that you voluntarily provide when
            submitting the Contact Us form, which may include:
          </p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Company name (if provided)</li>
            <li>Any information you choose to include in your message</li>
          </ul>
          <p>
            We do not collect sensitive personal data, financial information, or
            vehicle-related data through this website.
          </p>

          <h2>2. Purpose of Collection</h2>
          <ul>
            <li>Respond to your inquiries or requests</li>
            <li>Communicate with you regarding our services</li>
            <li>Maintain internal records related to business communications</li>
          </ul>
          <p>
            We do not use your information for marketing purposes unless you have
            explicitly requested such communication.
          </p>

          <h2>3. Legal Basis for Processing</h2>
          <ul>
            <li>
              <strong>Consent:</strong> By submitting the Contact Us form, you consent
              to processing your data
            </li>
            <li>
              <strong>Legitimate Business Purpose:</strong> Managing business
              communications
            </li>
            <li>
              <strong>Legal Obligation:</strong> Compliance with applicable laws
            </li>
          </ul>

          <h2>4. Data Protection and Compliance</h2>
          <ul>
            <li>
              <strong>India:</strong> Compliance with DPDPA obligations including
              purpose limitation and data minimization
            </li>
            <li>
              <strong>UAE:</strong> Processing personal data in line with PDPL
              requirements
            </li>
          </ul>

          <h2>5. Data Retention</h2>
          <p>
            Personal data is retained only as long as necessary to fulfill the purpose
            of the inquiry or meet legal obligations, after which it is securely
            deleted.
          </p>

          <h2>6. Your Rights</h2>
          <ul>
            <li>Request access to your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your personal data</li>
            <li>Withdraw consent at any time</li>
          </ul>

          <h2>7. Data Security</h2>
          <p>
            We use appropriate technical and organizational security measures.
            However, no online transmission is completely secure.
          </p>

          <h2>8. Third-Party Sharing</h2>
          <p>
            We do not sell, rent, or trade personal information. Data may be shared
            only with trusted service providers strictly for operational purposes and
            only where legally permitted.
          </p>

          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be
            reflected on this page with a revised date.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            If you have any questions or wish to exercise your data protection rights,
            please contact us:
          </p>
          <p>
            <strong>Email:</strong> info@autoassure360.com
          </p>
        </section>
      </main>
    </>
  );
};

export default PrivacyPolicy;
